import React from 'react';
import { FormattedMessage } from 'react-intl';

export const getDropdownOptionsUtils = (field, optionsArr) => optionsArr.map(value => (
  <FormattedMessage
    key={value}
    id={`ui-task-list.${field}.${value}`}
  >
    {(message) => (
      <option value={value}>
        {message}
      </option>
    )}
  </FormattedMessage>
));
